module.exports = __webpack_public_path__ + "img/cover-profile-page.5684150c.png";